import clsx from 'clsx'
import { HTMLAttributes, ReactNode } from 'react'

import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'
import { Heading } from '@/shared/ui/heading'

import cl from './helper-block.module.scss'

type HelperBlockAction = {
	actionLabel?: ReactNode
	actionOnClick?: () => void
	actionElementClasses?: string[]
}

interface HelperBlockProps extends HTMLAttributes<HTMLDivElement>, HelperBlockAction {
	heading?: ReactNode
	text?: ReactNode
	secondaryText?: ReactNode
}

export const HelperBlock = (props: HelperBlockProps) => {
	const {
		heading,
		text,
		secondaryText,
		actionLabel,
		actionOnClick,
		actionElementClasses = [],
		className,
		...rest
	} = props

	return (
		<div className={clsx(cl.root, className)} {...rest}>
			<div className={cl.text}>
				<Heading preset="h3">{heading}</Heading>
				<Text className={cl.text}>{text}</Text>
			</div>
			<div className={cl.info}>
				{actionOnClick && (
					<Button className={clsx(cl.info__button, ...actionElementClasses)} onClick={actionOnClick}>
						{actionLabel}
					</Button>
				)}
				{secondaryText && <div className={cl.info__secondaryText}>{secondaryText}</div>}
			</div>
		</div>
	)
}
